module.exports = __webpack_public_path__ + "img/CPTemp5.6d10f8ad.png";